import React from 'react';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { PiDotsThreeVertical } from 'react-icons/pi';
import { useLocalization } from '@ais-ui/locale-management';
import { ReportTemplate } from '@ais-ui/websockets';
import { useProfile } from '@ais-ui/profile';

interface ReportTemplateDropDownMenuProps {
  reportTemplate: ReportTemplate;
  onDelete: () => void;
  onSchedule: () => void;
  onDeleteSchedule: () => void;
  onShare: () => void;
  isScheduled: boolean;
}

export const ReportTemplateDropDownMenu = ({
  reportTemplate,
  onDelete,
  onSchedule,
  onDeleteSchedule,
  onShare,
  isScheduled,
}: ReportTemplateDropDownMenuProps) => {
  const { messages } = useLocalization();
  const { username } = useProfile();

  const isOwner = username === reportTemplate.tplOwner;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          id={`${reportTemplate.tplName}-dropdown-button`}
          size="icon"
          variant="ghost"
          className="size-7"
        >
          <PiDotsThreeVertical className="size-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {isScheduled && (
          <DropdownMenuItem onClick={onDeleteSchedule}>
            {messages.reportsTemplateDeleteSchedule}
          </DropdownMenuItem>
        )}
        {!isScheduled && (
          <DropdownMenuItem onClick={onSchedule}>
            {messages.reportsTemplateSchedule}
          </DropdownMenuItem>
        )}
        {isOwner ? (
          <DropdownMenuItem onClick={onShare}>
            {messages.reportsTemplateShare}
          </DropdownMenuItem>
        ) : (
          <Tooltip>
            <TooltipTrigger asChild>
              <div>
                <DropdownMenuItem 
                  disabled={true}
                  className="cursor-not-allowed"
                >
                  {messages.reportsTemplateShare}
                </DropdownMenuItem>
              </div>
            </TooltipTrigger>
            <TooltipContent>
              {messages.reportsTemplateShareDisabledTooltip}
            </TooltipContent>
          </Tooltip>
        )}
        <DropdownMenuItem onClick={onDelete}>
          {messages.genericDelete}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
